import { render, staticRenderFns } from "./_RoomingReceivedToggle.vue?vue&type=template&id=5956b547"
import script from "./_RoomingReceivedToggle.vue?vue&type=script&lang=js"
export * from "./_RoomingReceivedToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports